import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_44_1W_5_19',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_44_1w_5_19_usd',
			EUR: 'simple_premium_4w_44_1w_5_19_eur',
			GBP: 'simple_premium_4w_44_1w_5_19_gbp',
			AUD: 'simple_premium_4w_44_1w_7_99_aud',
			CAD: 'simple_premium_4w_44_1w_7_99_cad',
			DKK: 'simple_premium_4w_379_1w_39_dkk',
			SEK: 'simple_premium_4w_585_1w_59_sek',
			NOK: 'simple_premium_4w_585_1w_59_nok',
			MXN: 'simple_premium_4w_729_1w_79_mxn',
			BRL: 'simple_premium_4w_299_1w_25_99_brl',
			TRY: 'simple_premium_4w_1499_1w_169_try',
		},
		primer: 'prd_WENKtLRaJui0',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 5.19,
			EUR: 5.19,
			GBP: 5.19,
			AUD: 7.99,
			CAD: 7.99,
			DKK: 39,
			SEK: 59,
			NOK: 59,
			MXN: 79,
			BRL: 25.99,
			TRY: 169,
		},
		originalPriceMap: {
			USD: 9.99,
			EUR: 9.99,
			GBP: 9.99,
			AUD: 14.99,
			CAD: 14.99,
			DKK: 69,
			SEK: 110,
			NOK: 110,
			MXN: 129,
			BRL: 55.99,
			TRY: 333,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 44,
			GBP: 44,
			AUD: 44,
			CAD: 44,
			DKK: 379,
			SEK: 585,
			NOK: 585,
			MXN: 729,
			BRL: 299,
			TRY: 1499,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 1), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
	}),
}
